// Open information based on what animal is clicked
var infoOpens = document.getElementsByClassName('js-info-open');
for (var i = 0; i < infoOpens.length; i++) {
  infoOpens[i].addEventListener('click', function() {
    // Close any information modules that are already open
    var headerObjects = document.getElementsByClassName('js-header__object');
    for (var i = 0; i < headerObjects.length; i++) {
      var headerObject = headerObjects[i];
      headerObject.classList.remove('is-active');
      headerObject.classList.remove('is-in-front');
    }
    // Open information
    var target = this.dataset.target;
    for (var i = 0; i < headerObjects.length; i++) {
      var headerObject = headerObjects[i];
      if (headerObjects[i].dataset.name == target) {
        headerObject.classList.add('is-active');
      }
      // Make fish stay in front of open coral
      if (target == 'coral') {
        var fishObjects = document.getElementsByClassName('header__object--fish');
        fishObjects[0].classList.add('is-in-front');
        fishObjects[1].classList.add('is-in-front');
        fishObjects[2].classList.add('is-in-front');
      }
    }
  });
}

// Close information modules
var infoCloses = document.getElementsByClassName('js-info-close');
for (var i = 0; i < infoCloses.length; i++) {
  infoCloses[i].addEventListener('click', function() {
    var headerObjects = document.getElementsByClassName('js-header__object');
    for (var i = 0; i < headerObjects.length; i++) {
      var headerObject = headerObjects[i];
      headerObject.classList.remove('is-active');
      headerObject.classList.remove('is-in-front');
    }
  });
}

// Set the parallax container
var parallaxContainer = document.getElementsByClassName('js-header')[0];

// Set the parallax values
parallaxContainer.onmousemove = function(event) {
  event = event || window.event;
  var x = event.clientX - parallaxContainer.offsetLeft,
  y = event.clientY - parallaxContainer.offsetTop;
  // Background layers (sea, sand)
  mouseParallax(1, 0, 0, x, y, 2);
  // Background fish
  mouseParallax(2, 0, 0, x, y, 2);
  // Monsters
  mouseParallax(3, 0, 0, x, y, 12);
  // Sealion, dolphin and turtle
  mouseParallax(4, 0, 0, x, y, 10);
  // Coral
  mouseParallax(5, 0, 0, x, y, 8);
  // Fish and bottle
  mouseParallax(6, 0, 0, x, y, 6);
}

// Use parallax to move the elements with the mouse
function mouseParallax(parallaxLayer, left, top, mouseX, mouseY, speed) {
  var objectsinLayer = document.querySelectorAll("[data-parallax-layer='" + parallaxLayer + "']");
  for (var i = 0; i < objectsinLayer.length; i++) {
    var object = objectsinLayer[i];
    var parallaxStart = 1064;
    var parentObject = object.parentNode,
    containerWidth = parseInt(parentObject.offsetWidth),
    containerHeight = parseInt(parentObject.offsetHeight);
    var horizontalPosition = (left - (((mouseX - (parseInt(object.offsetWidth) / 2 + left)) / containerWidth) * speed));
    var verticalPosition = (top - (((mouseY - (parseInt(object.offsetHeight) / 2 + top)) / containerHeight) * speed));
    if (containerWidth > parallaxStart) {
      object.style.transform = "translateX(" + horizontalPosition + "%) translateY(" + verticalPosition + "%)";
    }
  }
}
